import { useEffect, useState } from "react";

/**
 * Debounced value hook — mirrors the input state after `delay` ms of quiet.
 * Used by the report search field so a keystroke storm doesn't fan out into
 * one API request per keystroke.
 */
export function useDebounced<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
